import FullScreenPage from "../../../components/FullScreenPage/FullScreenPage"
import { useNavigation } from "../../../components/NavigationController/NavigationController"
import PrimaryButton from "../../../components/PrimaryButton/PrimaryButton"
import useStrings from "../../../localization/useStrings"
import styles from "./SimplePaywallStep.module.scss"

interface Props extends React.PropsWithChildren {}

const SimplePaywallStep = (props: Props) => {
  const strings = useStrings()
  const { push } = useNavigation()

  return (
    <FullScreenPage containerClassName={styles.container}>
      <div className={styles.content}>{props.children}</div>
      <div className={styles.footer}>
        <PrimaryButton className={styles.cta} onClick={push}>
          {strings.animated.cta}
        </PrimaryButton>
      </div>
    </FullScreenPage>
  )
}

export default SimplePaywallStep
